export default __webpack_public_path__ + "static/dummyRoundThree-2dd2aa8ef6b5f95f0404c2e1e6008674.png";